module.exports = __webpack_public_path__ + "static/img/twitter_icon.64cab27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/twitter_icon.svg
// module id = K4Xg
// module chunks = 1